import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { map } from 'ramda'
import { ExternalRadioGroup } from '..'
import { useResidenceDependentVisibility } from '../../utils/hooks'

const residenceDependentFields = ['isSwiftOrIban']
/**
 * @param {OptionProps} list
 * @param {?string} validValue
 * @param {?boolean} isVertical
 * @param {string} label
 * @param {string} name
 * @param {?string} defaultValue
 * @param {?string[]} requiredForCountries
 */
const ExternalRadioGroupCountryDependent = ({
  list,
  validValue,
  isVertical,
  label,
  name,
  defaultValue,
  requiredForCountries
}) => {
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const [isShown, setIsShown] = useState(
    !requiredForCountries ||
    !requiredForCountries.length ||
    !residenceDependentFields.includes(name)
  )

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalRadioGroup
      list={list}
      validValue={validValue}
      isVertical={isVertical}
      label={label}
      name={name}
      defaultValue={defaultValue}
    />
  ) : null
}

const getExternalRadioGroupCountryDependentFields = map(radioButtonField => {
  return (
    <ExternalRadioGroupCountryDependent
      {...radioButtonField}
      key={radioButtonField.name}
      label={`generatedField.${radioButtonField.i18n}`}
    />
  )
})

export { ExternalRadioGroupCountryDependent, getExternalRadioGroupCountryDependentFields }
